import type { AxiosInstance, AxiosResponse } from 'axios';
import type {
	PpdfSouhlasySouhlasDto,
	PpdfSouhlasySouhlasSeznamDto,
	PpdfSouhlasyStahniVsechnySouhlasyPpdfParams,
} from '@gov-nx/api';
import { govApiLog } from '@gov-nx/core/app';
import type { PpdfConsentsDataRequest } from '@gov-nx/module/page';

export const ppdfConsentsQuery = async (
	axiosInstance: AxiosInstance,
	filter: PpdfConsentsDataRequest
): Promise<PpdfSouhlasySouhlasSeznamDto> => {
	govApiLog('/api/v1/ppdf');
	const { data } = await axiosInstance.get('/api/v1/ppdf', {
		params: { ...filter },
	});
	return data;
};

export const ppdfConsentDetailQuery = async (
	axiosInstance: AxiosInstance,
	consentId: string
): Promise<PpdfSouhlasySouhlasDto> => {
	const { data } = await axiosInstance.get('/api/v1/ppdf/' + consentId);
	return data;
};

export const ppdfConsentDownloadQuery = async ({
	id,
	axiosInstance,
}: {
	id: string;
	axiosInstance: AxiosInstance;
}): Promise<AxiosResponse<Blob>> =>
	await axiosInstance.get(`/api/v1/ppdf/${id}/stahnout`, {
		responseType: 'blob',
	});

export const ppdfDownloadAllConsentsQuery = async ({
	axiosInstance,
	params,
}: {
	axiosInstance: AxiosInstance;
	params?: PpdfSouhlasyStahniVsechnySouhlasyPpdfParams;
}): Promise<AxiosResponse<Blob>> =>
	await axiosInstance.get('/api/v1/ppdf/stahnout', {
		responseType: 'blob',
		params,
	});
